import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { SectionTitle } from '../Section';

export const PaddingWrapper = styled.div`
  padding: 50px 0px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const Title = styled(SectionTitle)`
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
`;

export const ContentWrapper = styled.div`
  width: 50%;
  font-size: 16px;
  line-height: 1.8;
  text-align: center;
  width: 50%;
  order: 1;
  ${mediaQuery('tablet')} {
    width: 100%;
  }
`;

export const Image = styled.img<{ imageOnLeft: boolean }>`
  object-fit: cover;
  height: 100%;
  width: 50%;
  max-width: 300px;
  max-height: 300px;
  border-radius: 5px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
  order: ${(props) => (props.imageOnLeft ? 0 : 2)};
  ${(props) => (props.imageOnLeft ? 'margin-right: 80px;' : 'margin-left: 80px;')}

  ${mediaQuery('tablet')} {
    margin: 0;
    margin-bottom: 30px;
    order: 0;
    max-width: 250px;
    max-height: 250px;
    width: 100%;
  }
`;
